import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { http, fmtErr } from "../lib/api";

export function WholesalerSupportCard() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "", business_name: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await http.post("/contact", { ...form, contact_type: "wholesaler" });
      setDone(true);
      toast.success("Message sent!");
    } catch (err) { toast.error(fmtErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  const input = "w-full bg-white border border-[#E5D8C1] px-4 py-3 focus:outline-none focus:border-[#D32F2F]";
  if (done) {
    return (
      <div className="bg-[#7CB342]/15 border border-[#7CB342] p-6" data-testid="wholesaler-support-success">
        <div className="font-heading text-xl uppercase tracking-wide">Message received</div>
        <p className="text-[#5C5A56] mt-1 text-sm">Our wholesale team responds within one business day.</p>
      </div>
    );
  }
  return (
    <form onSubmit={submit} className="bg-[#1A1A1A] text-[#FFFDF8] p-6 md:p-8 space-y-4" data-testid="wholesaler-support-form">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-[#FFB300]">Already wholesale?</div>
        <div className="font-heading text-3xl uppercase tracking-wide mt-1">Talk to our wholesale team</div>
        <p className="text-white/70 text-sm mt-2">Reorders, invoices, custom cases, escalations — hit us up directly.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        <input required placeholder="Your name *" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className={input} data-testid="wholesaler-support-name" />
        <input required type="email" placeholder="Email *" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className={input} data-testid="wholesaler-support-email" />
      </div>
      <input required placeholder="Business name *" value={form.business_name} onChange={(e) => setForm({...form, business_name: e.target.value})} className={input} data-testid="wholesaler-support-business" />
      <input placeholder="Phone" value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} className={input} data-testid="wholesaler-support-phone" />
      <textarea required rows={4} placeholder="How can we help? *" value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} className={input + " resize-none"} data-testid="wholesaler-support-message" />
      <button type="submit" disabled={loading} className="w-full bg-[#D32F2F] hover:bg-[#B71C1C] py-3 uppercase tracking-widest font-heading disabled:opacity-60 flex items-center justify-center gap-2" data-testid="wholesaler-support-submit">
        {loading && <Loader2 className="animate-spin" size={16} />} Send message
      </button>
    </form>
  );
}
